
import React from 'react';
import { Box, Button } from '@mui/material';
import './SubTitle.css';
import { useTranslation } from 'react-i18next';

export default function MonitorSubtitle({
    title,
    path,
    add,
    addPath,
    track,
    trackPath,
    onAddClick,
    onTrackClick
}) {
    const { t } = useTranslation();

    // Function to translate path segments
    const translatePath = (path) => {
        // Split the path into segments
        const segments = path.split('>');

        // Translate each segment and join with '>'
        return segments
            .map(segment => t(segment.trim()))
            .join(' > ');
    };

    const handleAddClick = () => {
        if (onAddClick) {
            onAddClick(addPath);
        }
    };

    const handleTrackClick = () => {
        if (onTrackClick) {
            onTrackClick(trackPath);
        }
    };

    return (
        <div className="subtitle-container">
            <div className="subtitle-left-content">
                <Box>
                    <span className="subtitle-text">{t(title)}</span>
                    <span className="subtitle-path">{translatePath(path)}</span>
                </Box>
            </div>

            <div className="subtitle-buttons">
                {track && (
                    <Button
                        sx={{
                            color: "#FFFFFF",
                            width: { xs: "100%", sm: "188px" },
                            height: "47px",
                            borderRadius: "8px",
                            padding: "12px 24px",
                            gap: "10px",

                            textTransform: "none",
                            "&:hover": {
                                background: "#1A8FC0"
                            }
                        }}
                        onClick={handleTrackClick}
                        style={{
                            height: "47px",
                            borderRadius: "8px",
                            border: "2px solid #20A8E0",
                            padding: "10px 20px",
                            color: "#20A8E0",
                            backgroundColor: "transparent",
                            cursor: "pointer",
                            fontSize: "16px",
                            fontWeight: "500",
                            transition: "all 0.3s ease",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        {t(track)}
                    </Button>
                )}

                {add && (
                    <Button
                        onClick={handleAddClick}
                        variant="contained"
                        sx={{
                            color: "#FFFFFF",
                            width: { xs: "100%", sm: "188px" },
                            height: "47px",
                            borderRadius: "8px",
                            padding: "12px 24px",
                            gap: "10px",
                            background: "#20A8E0",
                            textTransform: "none",
                            "&:hover": {
                                background: "#1A8FC0"
                            }
                        }}
                    >
                        {t(add)}
                    </Button>
                )}
            </div>
        </div >
    );
}